var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_48230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.722 97.3833C110.215 51.5169 106.482 43.8369 97.3084 43.8369H54.898C44.7967 43.8369 41.2447 52.7009 38.7061 107.986C38.7061 118.588 45.106 126.3 54.13 126.3H91.3244",
    stroke: "#BCBCBC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1685 60.0413C56.1685 43.1134 65.0004 29.2041 75.7843 29.2041C86.5683 29.2041 95.4536 42.964 95.4536 60.0413",
    stroke: "#BCBCBC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.213 132.67C108.868 132.672 112.441 131.59 115.48 129.561C118.52 127.533 120.889 124.648 122.289 121.273C123.689 117.897 124.057 114.182 123.345 110.598C122.633 107.013 120.875 103.72 118.291 101.136C115.708 98.5508 112.416 96.7902 108.832 96.0765C105.248 95.3628 101.533 95.728 98.1566 97.126C94.7802 98.524 91.8943 100.892 89.8638 103.93C87.8333 106.969 86.7495 110.541 86.7495 114.195C86.7495 119.093 88.6945 123.791 92.1568 127.255C95.6192 130.719 100.315 132.667 105.213 132.67V132.67Z",
    stroke: "#6A148E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.201 121.3C104.72 121.296 104.249 121.433 103.846 121.695C103.445 121.955 103.126 122.325 102.929 122.761C102.742 123.206 102.69 123.695 102.78 124.169C102.856 124.644 103.071 125.086 103.398 125.439C103.739 125.78 104.172 126.014 104.644 126.111C105.117 126.207 105.607 126.163 106.054 125.983C106.487 125.791 106.857 125.48 107.121 125.087C107.385 124.684 107.526 124.213 107.526 123.732C107.528 123.094 107.279 122.481 106.833 122.025C106.399 121.588 105.816 121.329 105.201 121.3Z",
    fill: "#6A148E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.202 119.027C104.59 119.024 104.004 118.779 103.573 118.345C103.141 117.912 102.898 117.325 102.898 116.713V103.838C102.877 103.521 102.921 103.204 103.027 102.905C103.133 102.606 103.3 102.332 103.516 102.101C103.733 101.869 103.995 101.684 104.286 101.558C104.577 101.431 104.891 101.366 105.208 101.366C105.525 101.366 105.839 101.431 106.13 101.558C106.421 101.684 106.682 101.869 106.899 102.101C107.116 102.332 107.282 102.606 107.388 102.905C107.495 103.204 107.539 103.521 107.517 103.838V116.713C107.517 117.326 107.273 117.915 106.839 118.349C106.405 118.783 105.816 119.027 105.202 119.027Z",
    fill: "#6A148E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88847 78.1644C6.6909 78.1644 7.3414 77.5146 7.3414 76.7131C7.3414 75.9115 6.6909 75.2617 5.88847 75.2617C5.08604 75.2617 4.43555 75.9115 4.43555 76.7131C4.43555 77.5146 5.08604 78.1644 5.88847 78.1644Z",
    fill: "#C198ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0443 10.9038C25.3492 10.9038 26.407 9.84718 26.407 8.54372C26.407 7.24026 25.3492 6.18359 24.0443 6.18359C22.7395 6.18359 21.6816 7.24026 21.6816 8.54372C21.6816 9.84718 22.7395 10.9038 24.0443 10.9038Z",
    stroke: "#C198ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9061 146.797C21.7085 146.797 22.359 146.147 22.359 145.346C22.359 144.544 21.7085 143.895 20.9061 143.895C20.1036 143.895 19.4531 144.544 19.4531 145.346C19.4531 146.147 20.1036 146.797 20.9061 146.797Z",
    fill: "#BCBCBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.32 3.90268C144.123 3.90268 144.773 3.25289 144.773 2.45134C144.773 1.64979 144.123 1 143.32 1C142.518 1 141.867 1.64979 141.867 2.45134C141.867 3.25289 142.518 3.90268 143.32 3.90268Z",
    fill: "#C198ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.378 156.626C111.683 156.626 112.741 155.57 112.741 154.266C112.741 152.963 111.683 151.906 110.378 151.906C109.073 151.906 108.016 152.963 108.016 154.266C108.016 155.57 109.073 156.626 110.378 156.626Z",
    stroke: "#C198ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.594 59.43C153.396 59.43 154.046 58.7802 154.046 57.9787C154.046 57.1771 153.396 56.5273 152.594 56.5273C151.791 56.5273 151.141 57.1771 151.141 57.9787C151.141 58.7802 151.791 59.43 152.594 59.43Z",
    fill: "#C198ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88037 27.6045V29.5577",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 31.1143H5.33034",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88037 32.708V34.607",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48193 31.1143H10.383",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L3.09113 3.10241",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41943 6.42676L8.44267 8.44778",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.44746L3.05039 6.38574",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39062 3.06172L8.44101 1",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.973 3.87012L157.385 5.28077",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.64 7.54199L160.998 8.91195",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.973 8.91271L157.358 7.51562",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.614 5.25364L160.999 3.87012",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.473 141.994V140.041",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.978 138.494H149.022",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.473 136.898V134.999",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.872 138.494H143.971",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.996 160.999L158.905 158.91",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.58 155.587L153.557 153.566",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161 153.566L158.95 155.615",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.621 158.952L153.557 161",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02401 159.725L4.61182 158.301",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37145 156.061L1 154.691",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02322 154.691L4.63818 156.075",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38503 158.343L1 159.726",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_48230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.666,
    height: 106.666,
    fill: "white",
    transform: "translate(27.6665 27.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.b8d06d7990c210c5d65101549d9ca9c9.svg";
export { ForwardRef as ReactComponent };